import { useMutation, useQueryClient } from 'react-query';
import { cacheKeys } from './cacheKeys';
import { handleRequest } from '../../../../redux/services/APIService';
import storageHelper from '../../../../libs/storageHelper';
import { toast } from 'react-toastify';

export const useCreateTopic = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data = { title: '', service: '', isCustom: true }) => {
      const { user } = storageHelper.getFromStorage('loggedUser');
      return handleRequest(
        'post',
        `facility/${user.facility}/topics`,
        true,
        {
          title: data.title,
          service: data.service,
          isCustom: true,
        },
      );
    },
    {
      onSuccess: async () => {
        toast('Topic was successfully created', {
          type: 'success',
          style: { width: 'auto' },
        });
        queryClient.invalidateQueries(cacheKeys.getTopics());
      },
      onError: async (err) => {
        toast('Unable to create Topic', {
          type: 'error',
          style: { width: 'auto' },
        });
        console.error(
          `Failed to create topic: ${
            err.response?.data.message || err.message
          }`,
        );
      },
    },
  );

  return mutation;
};
